import api from 'api/api.config';

const getRegimesPath = (userId: string, modelId: string | number): string =>
  `/${userId}/aid-models/${modelId}/regimes`;

const getRegimeGroupsPath = (
  userId: string,
  modelId: string | number
): string => `/${userId}/aid-models/${modelId}/regime-groups`;

export const getRegimes = async (
  userId: string,
  modelId: string | number
): Promise<unknown> => {
  const response = await api.get(getRegimesPath(userId, modelId));

  return response.data;
};

export const createRegime = async (
  userId: string,
  modelId: string | number,
  data: unknown
): Promise<unknown> => {
  const response = await api.post(
    getRegimesPath(userId, modelId),
    JSON.stringify(data)
  );

  return response.data;
};

export const getRegimeGroups = async (
  userId: string,
  modelId: string | number
): Promise<unknown> => {
  const response = await api.get(getRegimeGroupsPath(userId, modelId));

  return response.data;
};

export const createRegimeGroup = async (
  userId: string,
  modelId: string | number,
  data: unknown
): Promise<unknown> => {
  const response = await api.post(
    getRegimeGroupsPath(userId, modelId),
    JSON.stringify(data)
  );

  return response.data;
};

export const updateRegimeGroup = async (
  userId: string,
  modelId: string | number,
  groupId: string | number,
  data: unknown
): Promise<unknown> => {
  const response = await api.put(
    `${getRegimeGroupsPath(userId, modelId)}/${groupId}`,
    JSON.stringify(data)
  );

  return response.data;
};

export const deleteRegimeGroup = async (
  userId: string,
  modelId: string | number,
  groupId: string | number
): Promise<void> => {
  await api.delete(`${getRegimeGroupsPath(userId, modelId)}/${groupId}`);
};

export const updateRegime = async (
  userId: string,
  modelId: string | number,
  regimeId: string | number,
  data: unknown
): Promise<unknown> => {
  const response = await api.patch(
    `${getRegimesPath(userId, modelId)}/${regimeId}`,
    JSON.stringify(data)
  );

  return response.data;
};

export const deleteRegime = async (
  userId: string,
  modelId: string | number,
  regimeId: string | number
): Promise<void> => {
  await api.delete(`${getRegimesPath(userId, modelId)}/${regimeId}`);
};

export const validateRegimeGroup = async (
  userId: string,
  modelId: string | number,
  groupId: string | number
): Promise<unknown> => {
  const response = await api.get(
    `${getRegimeGroupsPath(userId, modelId)}/${groupId}/validate`
  );

  return response.data;
};

export const copyRegime = async (
  userId: string,
  modelId: string | number,
  regimeId: string | number,
  data: unknown
): Promise<unknown> => {
  const response = await api.post(
    `${getRegimesPath(userId, modelId)}/${regimeId}/copy`,
    JSON.stringify(data)
  );

  return response.data;
};
